/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * MyDrcAPI
 * My DRC - Reise Checkliste
 *
 * OpenAPI spec version: 1.0
 * Contact: jan.illetschko@3kraft.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * Checklist category data transfer object
 * @export
 * @interface ChecklistCategoryDto
 */
export interface ChecklistCategoryDto {
    /**
     * The category's color code
     * @type {string}
     * @memberof ChecklistCategoryDto
     */
    color?: string;
    /**
     * The category's icon url
     * @type {string}
     * @memberof ChecklistCategoryDto
     */
    icon?: string;
    /**
     * The category's id
     * @type {number}
     * @memberof ChecklistCategoryDto
     */
    id?: number;
    /**
     * The category's name
     * @type {string}
     * @memberof ChecklistCategoryDto
     */
    name: string;
    /**
     * The current category's order position
     * @type {number}
     * @memberof ChecklistCategoryDto
     */
    order?: number;
    /**
     * 
     * @type {ParticipantDto}
     * @memberof ChecklistCategoryDto
     */
    owner?: ParticipantDto;
}

/**
 * Checklist data transfer object
 * @export
 * @interface ChecklistDto
 */
export interface ChecklistDto {
    /**
     * A list of the checklist's categories on this trip
     * @type {Array&lt;ChecklistCategoryDto&gt;}
     * @memberof ChecklistDto
     */
    categories?: Array<ChecklistCategoryDto>;
    /**
     * Which filters were used to create the current checklist
     * @type {Array&lt;string&gt;}
     * @memberof ChecklistDto
     */
    createdFromFilters?: Array<string>;
    /**
     * A list of the checklist's items on this trip
     * @type {Array&lt;ChecklistItemDto&gt;}
     * @memberof ChecklistDto
     */
    items?: Array<ChecklistItemDto>;
    /**
     * Which filters are currently assigned/selected to the current checklist
     * @type {Array&lt;number&gt;}
     * @memberof ChecklistDto
     */
    selectedFilters: Array<number>;
    /**
     * Which destination filter items should be added to the checklist. This property is used on edit checklist only (will be ignore otherwise). Depending on the content the implementation behave differently: If the property is unset, all missing items assigned to the trips`s destinations will be added (this was the original behaviour). If the property is set to an empty array/list ([]), items assigned to the trip`s destinations will stay unchanged. If the property contains destination ids, missing items for this destinations will be added to the checklist. Therefore only newly added destinations should be passed to the server.
     * @type {Array&lt;number&gt;}
     * @memberof ChecklistDto
     */
    selectedDestinations?: Array<number>;
    /**
     * The checklist's trip id
     * @type {number}
     * @memberof ChecklistDto
     */
    tripId?: number;
}

/**
 * Checklist item data transfer object
 * @export
 * @interface ChecklistItemDto
 */
export interface ChecklistItemDto {
    /**
     * The category id, the item belongs to
     * @type {number}
     * @memberof ChecklistItemDto
     */
    category?: number;
    /**
     * Is the checklist item checked
     * @type {boolean}
     * @memberof ChecklistItemDto
     */
    checked?: boolean;
    /**
     * Is the checklist item marked as hand baggage (item's tag)
     * @type {boolean}
     * @memberof ChecklistItemDto
     */
    handBaggage?: boolean;
    /**
     * The checklist's item id
     * @type {number}
     * @memberof ChecklistItemDto
     */
    id?: number;
    /**
     * Is the checklist item marked as important (item's tag)
     * @type {boolean}
     * @memberof ChecklistItemDto
     */
    important?: boolean;
    /**
     * More related information regarding the item
     * @type {string}
     * @memberof ChecklistItemDto
     */
    info?: string;
    /**
     * Checklist item link
     * @type {string}
     * @memberof ChecklistItemDto
     */
    link?: string;
    /**
     * The name of the checklist's item
     * @type {string}
     * @memberof ChecklistItemDto
     */
    name: string;
    /**
     * Is the item newly created
     * @type {boolean}
     * @memberof ChecklistItemDto
     */
    newItem?: boolean;
    /**
     * The current checklist item's order position in the list
     * @type {number}
     * @memberof ChecklistItemDto
     */
    order?: number;
    /**
     * 
     * @type {ParticipantDto}
     * @memberof ChecklistItemDto
     */
    handler?: ParticipantDto;
}

/**
 * Checklist item state data transfer object
 * @export
 * @interface ChecklistItemStateDto
 */
export interface ChecklistItemStateDto {
    /**
     * Is the item checked
     * @type {boolean}
     * @memberof ChecklistItemStateDto
     */
    checked: boolean;
}

/**
 * Checklist item tag data transfer object
 * @export
 * @interface ChecklistItemTagDto
 */
export interface ChecklistItemTagDto {
    /**
     * Is the checklist item marked as hand baggage
     * @type {boolean}
     * @memberof ChecklistItemTagDto
     */
    handBaggage?: boolean;
    /**
     * Is the checklist item marked as important
     * @type {boolean}
     * @memberof ChecklistItemTagDto
     */
    important?: boolean;
}

/**
 * 
 * @export
 * @interface ChecklistItemsCountDto
 */
export interface ChecklistItemsCountDto {
    /**
     * count of all items in the checklist
     * @type {number}
     * @memberof ChecklistItemsCountDto
     */
    overall?: number;
    /**
     * count of completed items in the checklist
     * @type {number}
     * @memberof ChecklistItemsCountDto
     */
    checked?: number;
}

/**
 * Continent data transfer object
 * @export
 * @interface ContinentDto
 */
export interface ContinentDto {
    /**
     * Names of the countries that reside in the specified continent
     * @type {Array&lt;string&gt;}
     * @memberof ContinentDto
     */
    countries?: Array<string>;
    /**
     * The continent's id
     * @type {number}
     * @memberof ContinentDto
     */
    id?: number;
    /**
     * Name of the continent
     * @type {string}
     * @memberof ContinentDto
     */
    name: string;
    /**
     * In what order does the continent appear in lists
     * @type {number}
     * @memberof ContinentDto
     */
    order?: number;
    /**
     * Top lander
     * @type {Array&lt;string&gt;}
     * @memberof ContinentDto
     */
    topLander?: Array<string>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperChecklistCategoryDto
 */
export interface DataWrapperChecklistCategoryDto {
    /**
     * 
     * @type {ChecklistCategoryDto}
     * @memberof DataWrapperChecklistCategoryDto
     */
    data?: ChecklistCategoryDto;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperChecklistDto
 */
export interface DataWrapperChecklistDto {
    /**
     * 
     * @type {ChecklistDto}
     * @memberof DataWrapperChecklistDto
     */
    data?: ChecklistDto;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperChecklistItemDto
 */
export interface DataWrapperChecklistItemDto {
    /**
     * 
     * @type {ChecklistItemDto}
     * @memberof DataWrapperChecklistItemDto
     */
    data?: ChecklistItemDto;
}

/**
 * 
 * @export
 * @interface DataWrapperChecklistItemsCountDto
 */
export interface DataWrapperChecklistItemsCountDto {
    /**
     * 
     * @type {ChecklistItemsCountDto}
     * @memberof DataWrapperChecklistItemsCountDto
     */
    data?: ChecklistItemsCountDto;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperDestinationDto
 */
export interface DataWrapperDestinationDto {
    /**
     * 
     * @type {DestinationDto}
     * @memberof DataWrapperDestinationDto
     */
    data?: DestinationDto;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperFilterGroupItemsDto
 */
export interface DataWrapperFilterGroupItemsDto {
    /**
     * 
     * @type {FilterGroupItemsDto}
     * @memberof DataWrapperFilterGroupItemsDto
     */
    data?: FilterGroupItemsDto;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListChecklistCategoryDto
 */
export interface DataWrapperListChecklistCategoryDto {
    /**
     * 
     * @type {Array&lt;ChecklistCategoryDto&gt;}
     * @memberof DataWrapperListChecklistCategoryDto
     */
    data?: Array<ChecklistCategoryDto>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListContinentDto
 */
export interface DataWrapperListContinentDto {
    /**
     * 
     * @type {Array&lt;ContinentDto&gt;}
     * @memberof DataWrapperListContinentDto
     */
    data?: Array<ContinentDto>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListDestinationDto
 */
export interface DataWrapperListDestinationDto {
    /**
     * 
     * @type {Array&lt;DestinationDto&gt;}
     * @memberof DataWrapperListDestinationDto
     */
    data?: Array<DestinationDto>;
}

/**
 * 
 * @export
 * @interface DataWrapperListNotificationDto
 */
export interface DataWrapperListNotificationDto {
    /**
     * 
     * @type {Array&lt;NotificationDto&gt;}
     * @memberof DataWrapperListNotificationDto
     */
    data?: Array<NotificationDto>;
}

/**
 * a participant data transfer object
 * @export
 * @interface DataWrapperListParticipantDto
 */
export interface DataWrapperListParticipantDto {
    /**
     * 
     * @type {Array&lt;ParticipantDto&gt;}
     * @memberof DataWrapperListParticipantDto
     */
    data?: Array<ParticipantDto>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListTemplateDto
 */
export interface DataWrapperListTemplateDto {
    /**
     * 
     * @type {Array&lt;TemplateDto&gt;}
     * @memberof DataWrapperListTemplateDto
     */
    data?: Array<TemplateDto>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListTripDto
 */
export interface DataWrapperListTripDto {
    /**
     * 
     * @type {Array&lt;TripDto&gt;}
     * @memberof DataWrapperListTripDto
     */
    data?: Array<TripDto>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListTripPictureDto
 */
export interface DataWrapperListTripPictureDto {
    /**
     * 
     * @type {Array&lt;TripPictureDto&gt;}
     * @memberof DataWrapperListTripPictureDto
     */
    data?: Array<TripPictureDto>;
}

/**
 * 
 * @export
 * @interface DataWrapperListUserTemplateDto
 */
export interface DataWrapperListUserTemplateDto {
    /**
     * 
     * @type {Array&lt;UserTemplateDto&gt;}
     * @memberof DataWrapperListUserTemplateDto
     */
    data?: Array<UserTemplateDto>;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperListlong
 */
export interface DataWrapperListlong {
    /**
     * 
     * @type {Array&lt;number&gt;}
     * @memberof DataWrapperListlong
     */
    data?: Array<number>;
}

/**
 * Notification data transfer object
 * @export
 * @interface DataWrapperNotificationDto
 */
export interface DataWrapperNotificationDto {
    /**
     * 
     * @type {NotificationDto}
     * @memberof DataWrapperNotificationDto
     */
    data?: NotificationDto;
}

/**
 * a participant data transfer object
 * @export
 * @interface DataWrapperParticipantDto
 */
export interface DataWrapperParticipantDto {
    /**
     * 
     * @type {ParticipantDto}
     * @memberof DataWrapperParticipantDto
     */
    data?: ParticipantDto;
}

/**
 * 
 * @export
 * @interface DataWrapperTranslationDto
 */
export interface DataWrapperTranslationDto {
    /**
     * 
     * @type {TranslationDto}
     * @memberof DataWrapperTranslationDto
     */
    data?: TranslationDto;
}

/**
 * 
 * @export
 * @interface DataWrapperTravelAppConfigDto
 */
export interface DataWrapperTravelAppConfigDto {
    /**
     * 
     * @type {TravelAppConfigDto}
     * @memberof DataWrapperTravelAppConfigDto
     */
    data?: TravelAppConfigDto;
}

/**
 * Trip data transfer object
 * @export
 * @interface DataWrapperTripDto
 */
export interface DataWrapperTripDto {
    /**
     * 
     * @type {TripDto}
     * @memberof DataWrapperTripDto
     */
    data?: TripDto;
}

/**
 * 
 * @export
 * @interface DataWrapperUserTemplateDto
 */
export interface DataWrapperUserTemplateDto {
    /**
     * 
     * @type {UserTemplateDto}
     * @memberof DataWrapperUserTemplateDto
     */
    data?: UserTemplateDto;
}

/**
 * Destination data transfer object
 * @export
 * @interface DestinationDto
 */
export interface DestinationDto {
    /**
     * The destination's country code
     * @type {string}
     * @memberof DestinationDto
     */
    countryCode?: string;
    /**
     * The destination's gis rest alias
     * @type {string}
     * @memberof DestinationDto
     */
    gisRestAlias?: string;
    /**
     * The destination's id
     * @type {number}
     * @memberof DestinationDto
     */
    id?: number;
    /**
     * The destination's is deleted status
     * @type {boolean}
     * @memberof DestinationDto
     */
    isDeleted?: boolean;
    /**
     * The destination's language codes
     * @type {Array&lt;string&gt;}
     * @memberof DestinationDto
     */
    languageCodes?: Array<string>;
    /**
     * The destination's map box alias
     * @type {string}
     * @memberof DestinationDto
     */
    mapBoxAlias?: string;
    /**
     * The destination's name
     * @type {string}
     * @memberof DestinationDto
     */
    name: string;
    /**
     * The destination's parent's id, if it belongs to a parent
     * @type {number}
     * @memberof DestinationDto
     */
    parentId?: number;
    /**
     * The destination's parent's name, if it belongs to a parent
     * @type {string}
     * @memberof DestinationDto
     */
    parentName?: string;
    /**
     * The destination's parent's identifier in spunQ
     * @type {number}
     * @memberof DestinationDto
     */
    parentSpunqTextId?: number;
    /**
     * The destination's identifier in spunQ
     * @type {number}
     * @memberof DestinationDto
     */
    spunqTextId?: number;
    /**
     * Type of destination
     * @type {string}
     * @memberof DestinationDto
     */
    type?: DestinationDto.TypeEnum;
    /**
     * The destination's uuid
     * @type {string}
     * @memberof DestinationDto
     */
    uuid?: string;
    /**
     * Contains the absulate path to the flag image. Needs to prefixed by the corresponding environment domain (https://webint.oeamtc.at, https://beta.oeamtc.at, https://www.oeamtc.at).
     * @type {string}
     * @memberof DestinationDto
     */
    flagUri?: string;
    /**
     * 
     * @type {MapBoundariesDto}
     * @memberof DestinationDto
     */
    mapBoundaries?: MapBoundariesDto;
}

/**
 * @export
 * @namespace DestinationDto
 */
export namespace DestinationDto {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Country = <any> 'country',
        Region = <any> 'region',
        City = <any> 'city',
        Unknown = <any> 'unknown'
    }
}

/**
 * A DTO containing the data to send checklists via email/emarsys.
 * @export
 * @interface EmailDto
 */
export interface EmailDto {
    /**
     * The name of the sender
     * @type {string}
     * @memberof EmailDto
     */
    name?: string;
    /**
     * a list of recipients
     * @type {Array&lt;string&gt;}
     * @memberof EmailDto
     */
    recipients: Array<string>;
    /**
     * A personal message included into the email.
     * @type {string}
     * @memberof EmailDto
     */
    message: string;
}

/**
 * Filter data transfer object
 * @export
 * @interface FilterDto
 */
export interface FilterDto {
    /**
     * The filter's dependencies (which filters get displayed in case the current filter is selected)
     * @type {Array&lt;string&gt;}
     * @memberof FilterDto
     */
    dependency?: Array<string>;
    /**
     * The filter's icon constant
     * @type {string}
     * @memberof FilterDto
     */
    icon?: string;
    /**
     * The filter's id
     * @type {number}
     * @memberof FilterDto
     */
    id?: number;
    /**
     * The filter's name
     * @type {string}
     * @memberof FilterDto
     */
    name?: string;
    /**
     * Is the filter visible
     * @type {boolean}
     * @memberof FilterDto
     */
    visible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilterDto
     */
    order?: number;
}

/**
 * Filter group data transfer object
 * @export
 * @interface FilterGroupDto
 */
export interface FilterGroupDto {
    /**
     * The filter group's icon constant, if it has one
     * @type {string}
     * @memberof FilterGroupDto
     */
    icon?: string;
    /**
     * The filter group's id
     * @type {number}
     * @memberof FilterGroupDto
     */
    id?: number;
    /**
     * Does the group allow multiple selection of filters
     * @type {boolean}
     * @memberof FilterGroupDto
     */
    multipleSelection?: boolean;
    /**
     * The filter group's name
     * @type {string}
     * @memberof FilterGroupDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof FilterGroupDto
     */
    order?: number;
}

/**
 * Filter group item data transfer object
 * @export
 * @interface FilterGroupItemsDto
 */
export interface FilterGroupItemsDto {
    /**
     * Filter groups
     * @type {Array&lt;FilterGroupDto&gt;}
     * @memberof FilterGroupItemsDto
     */
    groups?: Array<FilterGroupDto>;
    /**
     * Filter items
     * @type {Array&lt;FilterDto&gt;}
     * @memberof FilterGroupItemsDto
     */
    items?: Array<FilterDto>;
}

/**
 * 
 * @export
 * @interface MapBoundariesDto
 */
export interface MapBoundariesDto {
    /**
     * Latitude A for map boundaries
     * @type {number}
     * @memberof MapBoundariesDto
     */
    latA?: number;
    /**
     * Longitude A for map boundaries
     * @type {number}
     * @memberof MapBoundariesDto
     */
    longA?: number;
    /**
     * Latitude B for map boundaries
     * @type {number}
     * @memberof MapBoundariesDto
     */
    latB?: number;
    /**
     * Longitude B for map boundaries
     * @type {number}
     * @memberof MapBoundariesDto
     */
    longB?: number;
}

/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * The notification's id
     * @type {number}
     * @memberof NotificationDto
     */
    id?: number;
    /**
     * 
     * @type {ParticipantDto}
     * @memberof NotificationDto
     */
    participant: ParticipantDto;
    /**
     * The notification message.
     * @type {string}
     * @memberof NotificationDto
     */
    text: string;
    /**
     * The date and time when the notifications was created.
     * @type {Date}
     * @memberof NotificationDto
     */
    created?: Date;
    /**
     * Flag whether the notification was created by a user or automatically by the system.
     * @type {boolean}
     * @memberof NotificationDto
     */
    userGenerated?: boolean;
}

/**
 * 
 * @export
 * @interface ParticipantDto
 */
export interface ParticipantDto {
    /**
     * The user's id
     * @type {number}
     * @memberof ParticipantDto
     */
    id?: number;
    /**
     * The user's firstname
     * @type {string}
     * @memberof ParticipantDto
     */
    firstname?: string;
    /**
     * The user's lastname
     * @type {string}
     * @memberof ParticipantDto
     */
    lastname?: string;
    /**
     * The particpants email address.
     * @type {string}
     * @memberof ParticipantDto
     */
    email?: string;
    /**
     * Is the user the owner of the checklist
     * @type {boolean}
     * @memberof ParticipantDto
     */
    listOwner?: boolean;
    /**
     * is this particpant the current user
     * @type {boolean}
     * @memberof ParticipantDto
     */
    current?: boolean;
    /**
     * The date when the notifications of a trip where viewed the last time by this user.
     * @type {Date}
     * @memberof ParticipantDto
     */
    notificationsViewedDate?: Date;
}

/**
 * Template data transfer object
 * @export
 * @interface TemplateDto
 */
export interface TemplateDto {
    /**
     * The predefined filter template's id
     * @type {string}
     * @memberof TemplateDto
     */
    id?: string;
    /**
     * The predefined filter template's name
     * @type {string}
     * @memberof TemplateDto
     */
    name?: string;
    /**
     * The predefined filter template's picture (url)
     * @type {string}
     * @memberof TemplateDto
     */
    picture?: string;
}

/**
 * 
 * @export
 * @interface TranslationDto
 */
export interface TranslationDto {
    /**
     * 
     * @type {string}
     * @memberof TranslationDto
     */
    lang: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TranslationDto
     */
    translations: { [key: string]: any; };
}

/**
 * 
 * @export
 * @interface TravelAppConfigDto
 */
export interface TravelAppConfigDto {
    /**
     * Deprecated, use version property instead.
     * @type {string}
     * @memberof TravelAppConfigDto
     */
    lang?: string;
    /**
     * 
     * @type {string}
     * @memberof TravelAppConfigDto
     */
    version?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TravelAppConfigDto
     */
    appConfig: { [key: string]: any; };
}

/**
 * Destination id's
 * @export
 * @interface TripDestinationDto
 */
export interface TripDestinationDto {
    /**
     * The destination's country code
     * @type {string}
     * @memberof TripDestinationDto
     */
    countryCode?: string;
    /**
     * The destination's gis rest alias
     * @type {string}
     * @memberof TripDestinationDto
     */
    gisRestAlias?: string;
    /**
     * The destination's id
     * @type {number}
     * @memberof TripDestinationDto
     */
    id?: number;
    /**
     * The destination's language codes
     * @type {Array&lt;string&gt;}
     * @memberof TripDestinationDto
     */
    languageCodes?: Array<string>;
    /**
     * The destination's map box alias
     * @type {string}
     * @memberof TripDestinationDto
     */
    mapBoxAlias?: string;
    /**
     * The destination's name
     * @type {string}
     * @memberof TripDestinationDto
     */
    name?: string;
    /**
     * The destination's parent's id, if it belongs to a parent
     * @type {number}
     * @memberof TripDestinationDto
     */
    parentId?: number;
    /**
     * The destination's parent's name, if it belongs to a parent
     * @type {string}
     * @memberof TripDestinationDto
     */
    parentName?: string;
    /**
     * The destination's parent's identifier in spunQ
     * @type {number}
     * @memberof TripDestinationDto
     */
    parentSpunqTextId?: number;
    /**
     * The destination's identifier in spunQ
     * @type {number}
     * @memberof TripDestinationDto
     */
    spunqTextId?: number;
    /**
     * Type of destination
     * @type {string}
     * @memberof TripDestinationDto
     */
    type?: TripDestinationDto.TypeEnum;
    /**
     * The destination's uuid
     * @type {string}
     * @memberof TripDestinationDto
     */
    uuid?: string;
    /**
     * Contains the absulate path to the flag image. Needs to prefixed by the corresponding environment domain (https://webint.oeamtc.at, https://beta.oeamtc.at, https://www.oeamtc.at).
     * @type {string}
     * @memberof TripDestinationDto
     */
    flagUri?: string;
    /**
     * 
     * @type {MapBoundariesDto}
     * @memberof TripDestinationDto
     */
    mapBoundaries?: MapBoundariesDto;
}

/**
 * @export
 * @namespace TripDestinationDto
 */
export namespace TripDestinationDto {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Country = <any> 'country',
        Region = <any> 'region',
        City = <any> 'city',
        Unknown = <any> 'unknown'
    }
}

/**
 * Trip data transfer object
 * @export
 * @interface TripDto
 */
export interface TripDto {
    /**
     * The trip's budget maximum value, the user does not want to exceed (only informational purpose, no transaction limit)
     * @type {number}
     * @memberof TripDto
     */
    budget?: number;
    /**
     * Indicator if a budget is created for the current trip
     * @type {boolean}
     * @memberof TripDto
     */
    budgetCreated?: boolean;
    /**
     * Indicator if a checklist is created for the current trip
     * @type {boolean}
     * @memberof TripDto
     */
    checklistCreated?: boolean;
    /**
     * Indicator if the current trip object is a demo trip (to discover the apps features)
     * @type {boolean}
     * @memberof TripDto
     */
    demo?: boolean;
    /**
     * The trip's destinations
     * @type {Array&lt;TripDestinationDto&gt;}
     * @memberof TripDto
     */
    destinations: Array<TripDestinationDto>;
    /**
     * The trip's end date (nullable)
     * @type {string}
     * @memberof TripDto
     */
    endDate?: string;
    /**
     * The trip id
     * @type {number}
     * @memberof TripDto
     */
    id?: number;
    /**
     * The trip's image url
     * @type {string}
     * @memberof TripDto
     */
    imageUrl?: string;
    /**
     * The trip's start date (nullable)
     * @type {string}
     * @memberof TripDto
     */
    startDate?: string;
    /**
     * The trip's title
     * @type {string}
     * @memberof TripDto
     */
    title: string;
    /**
     * The trip uuid
     * @type {string}
     * @memberof TripDto
     */
    uuid?: string;
    /**
     * The uuid to join a checklist
     * @type {string}
     * @memberof TripDto
     */
    shareId?: string;
}

/**
 * Trip Picture data transfer object
 * @export
 * @interface TripPictureDto
 */
export interface TripPictureDto {
    /**
     * The Trip picture id
     * @type {number}
     * @memberof TripPictureDto
     */
    id?: number;
    /**
     * The image url of the Trip picture
     * @type {string}
     * @memberof TripPictureDto
     */
    imageUrl: string;
    /**
     * The name of the Trip picture
     * @type {string}
     * @memberof TripPictureDto
     */
    name: string;
}

/**
 * Upload data transfer object
 * @export
 * @interface UploadDto
 */
export interface UploadDto {
    /**
     * The upload file name
     * @type {string}
     * @memberof UploadDto
     */
    filename: string;
    /**
     * The mime-type
     * @type {string}
     * @memberof UploadDto
     */
    mimeType: string;
    /**
     * base64 encoded file data
     * @type {string}
     * @memberof UploadDto
     */
    data: string;
}

/**
 * 
 * @export
 * @interface UserTemplateDto
 */
export interface UserTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UserTemplateDto
     */
    tripId: number;
}


/**
 * DestinationsApi - fetch parameter creator
 * @export
 */
export const DestinationsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get continents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinents(options: any = {}): FetchArgs {
            const localVarPath = `/destinations/continents`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get destination by id
         * @param {string} destinationId destination_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationById(destinationId: string, options: any = {}): FetchArgs {
            // verify required parameter 'destinationId' is not null or undefined
            if (destinationId === null || destinationId === undefined) {
                throw new RequiredError('destinationId','Required parameter destinationId was null or undefined when calling getDestinationById.');
            }
            const localVarPath = `/destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get destinations, filtered by their type
         * @param {string} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationFilters(type?: string, options: any = {}): FetchArgs {
            const localVarPath = `/destinations/filter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get destinations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinations(options: any = {}): FetchArgs {
            const localVarPath = `/destinations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DestinationsApi - functional programming interface
 * @export
 */
export const DestinationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get continents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinents(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListContinentDto> {
            const localVarFetchArgs = DestinationsApiFetchParamCreator(configuration).getContinents(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get destination by id
         * @param {string} destinationId destination_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationById(destinationId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperDestinationDto> {
            const localVarFetchArgs = DestinationsApiFetchParamCreator(configuration).getDestinationById(destinationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get destinations, filtered by their type
         * @param {string} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationFilters(type?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListDestinationDto> {
            const localVarFetchArgs = DestinationsApiFetchParamCreator(configuration).getDestinationFilters(type, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get destinations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinations(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListDestinationDto> {
            const localVarFetchArgs = DestinationsApiFetchParamCreator(configuration).getDestinations(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DestinationsApi - factory interface
 * @export
 */
export const DestinationsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get continents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContinents(options?: any) {
            return DestinationsApiFp(configuration).getContinents(options)(fetch, basePath);
        },
        /**
         * Get destination by id
         * @param {string} destinationId destination_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationById(destinationId: string, options?: any) {
            return DestinationsApiFp(configuration).getDestinationById(destinationId, options)(fetch, basePath);
        },
        /**
         * Get destinations, filtered by their type
         * @param {string} [type] type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationFilters(type?: string, options?: any) {
            return DestinationsApiFp(configuration).getDestinationFilters(type, options)(fetch, basePath);
        },
        /**
         * Get destinations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinations(options?: any) {
            return DestinationsApiFp(configuration).getDestinations(options)(fetch, basePath);
        },
    };
};

/**
 * DestinationsApi - object-oriented interface
 * @export
 * @class DestinationsApi
 * @extends {BaseAPI}
 */
export class DestinationsApi extends BaseAPI {
    /**
     * Get continents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public getContinents(options?: any) {
        return DestinationsApiFp(this.configuration).getContinents(options)(this.fetch, this.basePath);
    }

    /**
     * Get destination by id
     * @param {} destinationId destination_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public getDestinationById(destinationId: string, options?: any) {
        return DestinationsApiFp(this.configuration).getDestinationById(destinationId, options)(this.fetch, this.basePath);
    }

    /**
     * Get destinations, filtered by their type
     * @param {} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public getDestinationFilters(type?: string, options?: any) {
        return DestinationsApiFp(this.configuration).getDestinationFilters(type, options)(this.fetch, this.basePath);
    }

    /**
     * Get destinations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationsApi
     */
    public getDestinations(options?: any) {
        return DestinationsApiFp(this.configuration).getDestinations(options)(this.fetch, this.basePath);
    }

}

/**
 * EmarsysApi - fetch parameter creator
 * @export
 */
export const EmarsysApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * send checklist email to user via emarsys
         * @param {string} tripId trip_id
         * @param {EmailDto} checklistEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChecklist(tripId: string, checklistEmail: EmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling sendChecklist.');
            }
            // verify required parameter 'checklistEmail' is not null or undefined
            if (checklistEmail === null || checklistEmail === undefined) {
                throw new RequiredError('checklistEmail','Required parameter checklistEmail was null or undefined when calling sendChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/email`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(checklistEmail || {}) : (checklistEmail || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send shared trip invitation email to user via emarsys
         * @param {string} tripId trip_id
         * @param {EmailDto} invitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSharedTripInvitation(tripId: string, invitation: EmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling sendSharedTripInvitation.');
            }
            // verify required parameter 'invitation' is not null or undefined
            if (invitation === null || invitation === undefined) {
                throw new RequiredError('invitation','Required parameter invitation was null or undefined when calling sendSharedTripInvitation.');
            }
            const localVarPath = `/trips/{trip_id}/invitation/email`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(invitation || {}) : (invitation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmarsysApi - functional programming interface
 * @export
 */
export const EmarsysApiFp = function(configuration?: Configuration) {
    return {
        /**
         * send checklist email to user via emarsys
         * @param {string} tripId trip_id
         * @param {EmailDto} checklistEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChecklist(tripId: string, checklistEmail: EmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmarsysApiFetchParamCreator(configuration).sendChecklist(tripId, checklistEmail, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * send shared trip invitation email to user via emarsys
         * @param {string} tripId trip_id
         * @param {EmailDto} invitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSharedTripInvitation(tripId: string, invitation: EmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmarsysApiFetchParamCreator(configuration).sendSharedTripInvitation(tripId, invitation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EmarsysApi - factory interface
 * @export
 */
export const EmarsysApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * send checklist email to user via emarsys
         * @param {string} tripId trip_id
         * @param {EmailDto} checklistEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChecklist(tripId: string, checklistEmail: EmailDto, options?: any) {
            return EmarsysApiFp(configuration).sendChecklist(tripId, checklistEmail, options)(fetch, basePath);
        },
        /**
         * send shared trip invitation email to user via emarsys
         * @param {string} tripId trip_id
         * @param {EmailDto} invitation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSharedTripInvitation(tripId: string, invitation: EmailDto, options?: any) {
            return EmarsysApiFp(configuration).sendSharedTripInvitation(tripId, invitation, options)(fetch, basePath);
        },
    };
};

/**
 * EmarsysApi - object-oriented interface
 * @export
 * @class EmarsysApi
 * @extends {BaseAPI}
 */
export class EmarsysApi extends BaseAPI {
    /**
     * send checklist email to user via emarsys
     * @param {} tripId trip_id
     * @param {} checklistEmail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmarsysApi
     */
    public sendChecklist(tripId: string, checklistEmail: EmailDto, options?: any) {
        return EmarsysApiFp(this.configuration).sendChecklist(tripId, checklistEmail, options)(this.fetch, this.basePath);
    }

    /**
     * send shared trip invitation email to user via emarsys
     * @param {} tripId trip_id
     * @param {} invitation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmarsysApi
     */
    public sendSharedTripInvitation(tripId: string, invitation: EmailDto, options?: any) {
        return EmarsysApiFp(this.configuration).sendSharedTripInvitation(tripId, invitation, options)(this.fetch, this.basePath);
    }

}

/**
 * MyTripChecklistApi - fetch parameter creator
 * @export
 */
export const MyTripChecklistApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assigns an item to a list participant (item handler)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ParticipantDto} [handler] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignItemHandler(tripId: string, itemId: number, handler?: ParticipantDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling assignItemHandler.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling assignItemHandler.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/{item_id}/handler`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParticipantDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(handler || {}) : (handler || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check all checklist items
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllTripChecklistItems(tripId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling checkAllTripChecklistItems.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling checkAllTripChecklistItems.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/checkAll`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check multiple items by ids
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklistDto checklistDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling checkTripChecklistItems.');
            }
            // verify required parameter 'checklistDto' is not null or undefined
            if (checklistDto === null || checklistDto === undefined) {
                throw new RequiredError('checklistDto','Required parameter checklistDto was null or undefined when calling checkTripChecklistItems.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/checkByIds`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(checklistDto || {}) : (checklistDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * createChecklistPdf
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistPdf(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createChecklistPdf.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/pdf`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a checklist for a trip
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklist checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklist(tripId: string, checklist: ChecklistDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createTripChecklist.');
            }
            // verify required parameter 'checklist' is not null or undefined
            if (checklist === null || checklist === undefined) {
                throw new RequiredError('checklist','Required parameter checklist was null or undefined when calling createTripChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(checklist || {}) : (checklist || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a checklist category
         * @param {string} tripId trip_id
         * @param {ChecklistCategoryDto} category category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklistCategory(tripId: string, category: ChecklistCategoryDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createTripChecklistCategory.');
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling createTripChecklistCategory.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/categories`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistCategoryDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(category || {}) : (category || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a checklist item for a trip
         * @param {string} tripId trip_id
         * @param {ChecklistItemDto} item item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklistItem(tripId: string, item: ChecklistItemDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createTripChecklistItem.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling createTripChecklistItem.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete trip's checklist
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklist(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTripChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a checklist category
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklistCategory(tripId: string, categoryId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTripChecklistCategory.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling deleteTripChecklistCategory.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/categories/{category_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a checklist item
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklistItem(tripId: string, itemId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTripChecklistItem.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling deleteTripChecklistItem.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/{item_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip's checklist
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklist(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip's checklist by share id
         * @param {string} shareId share_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistByShareId(shareId: string, options: any = {}): FetchArgs {
            // verify required parameter 'shareId' is not null or undefined
            if (shareId === null || shareId === undefined) {
                throw new RequiredError('shareId','Required parameter shareId was null or undefined when calling getTripChecklistByShareId.');
            }
            const localVarPath = `/shared/trips/{share_id}/checklist`
                .replace(`{${"share_id"}}`, encodeURIComponent(String(shareId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip's checklist categories
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistCategories(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripChecklistCategories.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/categories`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip's checklist filters
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistFilters(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripChecklistFilters.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/filters`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip's checklist item counts
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistItemsCount(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripChecklistItemsCount.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/count`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move checklist item to another category
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {number} categoryId category_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTripCheckListItemToCategory(tripId: string, itemId: number, categoryId: number, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling moveTripCheckListItemToCategory.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling moveTripCheckListItemToCategory.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling moveTripCheckListItemToCategory.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling moveTripCheckListItemToCategory.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/moveitem/{item_id}/category/{category_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorder checklist categories
         * @param {string} tripId trip_id
         * @param {any} reorderedCategories reorderedCategories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderTripChecklistCategories(tripId: string, reorderedCategories: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling reorderTripChecklistCategories.');
            }
            // verify required parameter 'reorderedCategories' is not null or undefined
            if (reorderedCategories === null || reorderedCategories === undefined) {
                throw new RequiredError('reorderedCategories','Required parameter reorderedCategories was null or undefined when calling reorderTripChecklistCategories.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/categories/reorder`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(reorderedCategories || {}) : (reorderedCategories || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorder checklist items
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {any} reorderedItems reorderedItems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderTripChecklistCategoryItems(tripId: string, categoryId: number, reorderedItems: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling reorderTripChecklistCategoryItems.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling reorderTripChecklistCategoryItems.');
            }
            // verify required parameter 'reorderedItems' is not null or undefined
            if (reorderedItems === null || reorderedItems === undefined) {
                throw new RequiredError('reorderedItems','Required parameter reorderedItems was null or undefined when calling reorderTripChecklistCategoryItems.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/categories/{category_id}/items/reorder`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(reorderedItems || {}) : (reorderedItems || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create predefined checklist for an existing trip, through the predefined templates in the filter service.
         * @param {string} tripId trip_id
         * @param {string} templateId template_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTripPredefinedChecklist(tripId: string, templateId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling setTripPredefinedChecklist.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new RequiredError('templateId','Required parameter templateId was null or undefined when calling setTripPredefinedChecklist.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling setTripPredefinedChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/predefined/{template_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new checklist for an existing trip from a user defined checklist template.
         * @param {string} tripId trip_id
         * @param {string} templateTripId template_trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTripUserdefinedChecklist(tripId: string, templateTripId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling setTripUserdefinedChecklist.');
            }
            // verify required parameter 'templateTripId' is not null or undefined
            if (templateTripId === null || templateTripId === undefined) {
                throw new RequiredError('templateTripId','Required parameter templateTripId was null or undefined when calling setTripUserdefinedChecklist.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling setTripUserdefinedChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/userdefined/{template_trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"template_trip_id"}}`, encodeURIComponent(String(templateTripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * unassigns a list participant from the item (item handler)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignItemHandler(tripId: string, itemId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling unassignItemHandler.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling unassignItemHandler.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/{item_id}/handler`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uncheck all checklist items
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncheckAllTripChecklistItems(tripId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling uncheckAllTripChecklistItems.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling uncheckAllTripChecklistItems.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/uncheckAll`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uncheck multiple items by ids
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklistDto checklistDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncheckTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling uncheckTripChecklistItems.');
            }
            // verify required parameter 'checklistDto' is not null or undefined
            if (checklistDto === null || checklistDto === undefined) {
                throw new RequiredError('checklistDto','Required parameter checklistDto was null or undefined when calling uncheckTripChecklistItems.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/uncheckByIds`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(checklistDto || {}) : (checklistDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update trip's checklist
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklist checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklist(tripId: string, checklist: ChecklistDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTripChecklist.');
            }
            // verify required parameter 'checklist' is not null or undefined
            if (checklist === null || checklist === undefined) {
                throw new RequiredError('checklist','Required parameter checklist was null or undefined when calling updateTripChecklist.');
            }
            const localVarPath = `/trips/{trip_id}/checklist`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(checklist || {}) : (checklist || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a checklist category
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {ChecklistCategoryDto} category category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistCategory(tripId: string, categoryId: number, category: ChecklistCategoryDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTripChecklistCategory.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling updateTripChecklistCategory.');
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling updateTripChecklistCategory.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/categories/{category_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"category_id"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistCategoryDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(category || {}) : (category || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update trip's checklist item
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemDto} item item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItem(tripId: string, itemId: number, item: ChecklistItemDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTripChecklistItem.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling updateTripChecklistItem.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling updateTripChecklistItem.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/{item_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a checklist item's state (checked/unchecked)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemStateDto} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItemState(tripId: string, itemId: number, state: ChecklistItemStateDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTripChecklistItemState.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling updateTripChecklistItemState.');
            }
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling updateTripChecklistItemState.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/{item_id}/state`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistItemStateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(state || {}) : (state || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the trip's checklist item's tags properties
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemTagDto} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItemTag(tripId: string, itemId: number, tag: ChecklistItemTagDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTripChecklistItemTag.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling updateTripChecklistItemTag.');
            }
            // verify required parameter 'tag' is not null or undefined
            if (tag === null || tag === undefined) {
                throw new RequiredError('tag','Required parameter tag was null or undefined when calling updateTripChecklistItemTag.');
            }
            const localVarPath = `/trips/{trip_id}/checklist/items/{item_id}/tag`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChecklistItemTagDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(tag || {}) : (tag || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyTripChecklistApi - functional programming interface
 * @export
 */
export const MyTripChecklistApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Assigns an item to a list participant (item handler)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ParticipantDto} [handler] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignItemHandler(tripId: string, itemId: number, handler?: ParticipantDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperParticipantDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).assignItemHandler(tripId, itemId, handler, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check all checklist items
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllTripChecklistItems(tripId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).checkAllTripChecklistItems(tripId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Check multiple items by ids
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklistDto checklistDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).checkTripChecklistItems(tripId, checklistDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * createChecklistPdf
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistPdf(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).createChecklistPdf(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a checklist for a trip
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklist checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklist(tripId: string, checklist: ChecklistDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).createTripChecklist(tripId, checklist, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a checklist category
         * @param {string} tripId trip_id
         * @param {ChecklistCategoryDto} category category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklistCategory(tripId: string, category: ChecklistCategoryDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistCategoryDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).createTripChecklistCategory(tripId, category, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create a checklist item for a trip
         * @param {string} tripId trip_id
         * @param {ChecklistItemDto} item item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklistItem(tripId: string, item: ChecklistItemDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistItemDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).createTripChecklistItem(tripId, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete trip's checklist
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklist(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).deleteTripChecklist(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete a checklist category
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklistCategory(tripId: string, categoryId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).deleteTripChecklistCategory(tripId, categoryId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete a checklist item
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklistItem(tripId: string, itemId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).deleteTripChecklistItem(tripId, itemId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip's checklist
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklist(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).getTripChecklist(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip's checklist by share id
         * @param {string} shareId share_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistByShareId(shareId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).getTripChecklistByShareId(shareId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip's checklist categories
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistCategories(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListChecklistCategoryDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).getTripChecklistCategories(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip's checklist filters
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistFilters(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListlong> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).getTripChecklistFilters(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip's checklist item counts
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistItemsCount(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistItemsCountDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).getTripChecklistItemsCount(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Move checklist item to another category
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {number} categoryId category_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTripCheckListItemToCategory(tripId: string, itemId: number, categoryId: number, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).moveTripCheckListItemToCategory(tripId, itemId, categoryId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Reorder checklist categories
         * @param {string} tripId trip_id
         * @param {any} reorderedCategories reorderedCategories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderTripChecklistCategories(tripId: string, reorderedCategories: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).reorderTripChecklistCategories(tripId, reorderedCategories, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Reorder checklist items
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {any} reorderedItems reorderedItems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderTripChecklistCategoryItems(tripId: string, categoryId: number, reorderedItems: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).reorderTripChecklistCategoryItems(tripId, categoryId, reorderedItems, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create predefined checklist for an existing trip, through the predefined templates in the filter service.
         * @param {string} tripId trip_id
         * @param {string} templateId template_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTripPredefinedChecklist(tripId: string, templateId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).setTripPredefinedChecklist(tripId, templateId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates a new checklist for an existing trip from a user defined checklist template.
         * @param {string} tripId trip_id
         * @param {string} templateTripId template_trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTripUserdefinedChecklist(tripId: string, templateTripId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).setTripUserdefinedChecklist(tripId, templateTripId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * unassigns a list participant from the item (item handler)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignItemHandler(tripId: string, itemId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).unassignItemHandler(tripId, itemId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Uncheck all checklist items
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncheckAllTripChecklistItems(tripId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).uncheckAllTripChecklistItems(tripId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Uncheck multiple items by ids
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklistDto checklistDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncheckTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).uncheckTripChecklistItems(tripId, checklistDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update trip's checklist
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklist checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklist(tripId: string, checklist: ChecklistDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).updateTripChecklist(tripId, checklist, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update a checklist category
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {ChecklistCategoryDto} category category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistCategory(tripId: string, categoryId: number, category: ChecklistCategoryDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistCategoryDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).updateTripChecklistCategory(tripId, categoryId, category, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update trip's checklist item
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemDto} item item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItem(tripId: string, itemId: number, item: ChecklistItemDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).updateTripChecklistItem(tripId, itemId, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update a checklist item's state (checked/unchecked)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemStateDto} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItemState(tripId: string, itemId: number, state: ChecklistItemStateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).updateTripChecklistItemState(tripId, itemId, state, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update the trip's checklist item's tags properties
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemTagDto} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItemTag(tripId: string, itemId: number, tag: ChecklistItemTagDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistItemDto> {
            const localVarFetchArgs = MyTripChecklistApiFetchParamCreator(configuration).updateTripChecklistItemTag(tripId, itemId, tag, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MyTripChecklistApi - factory interface
 * @export
 */
export const MyTripChecklistApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Assigns an item to a list participant (item handler)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ParticipantDto} [handler] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignItemHandler(tripId: string, itemId: number, handler?: ParticipantDto, options?: any) {
            return MyTripChecklistApiFp(configuration).assignItemHandler(tripId, itemId, handler, options)(fetch, basePath);
        },
        /**
         * Check all checklist items
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllTripChecklistItems(tripId: string, dummyBody: any, options?: any) {
            return MyTripChecklistApiFp(configuration).checkAllTripChecklistItems(tripId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Check multiple items by ids
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklistDto checklistDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options?: any) {
            return MyTripChecklistApiFp(configuration).checkTripChecklistItems(tripId, checklistDto, options)(fetch, basePath);
        },
        /**
         * createChecklistPdf
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistPdf(tripId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).createChecklistPdf(tripId, options)(fetch, basePath);
        },
        /**
         * Create a checklist for a trip
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklist checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklist(tripId: string, checklist: ChecklistDto, options?: any) {
            return MyTripChecklistApiFp(configuration).createTripChecklist(tripId, checklist, options)(fetch, basePath);
        },
        /**
         * Create a checklist category
         * @param {string} tripId trip_id
         * @param {ChecklistCategoryDto} category category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklistCategory(tripId: string, category: ChecklistCategoryDto, options?: any) {
            return MyTripChecklistApiFp(configuration).createTripChecklistCategory(tripId, category, options)(fetch, basePath);
        },
        /**
         * Create a checklist item for a trip
         * @param {string} tripId trip_id
         * @param {ChecklistItemDto} item item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripChecklistItem(tripId: string, item: ChecklistItemDto, options?: any) {
            return MyTripChecklistApiFp(configuration).createTripChecklistItem(tripId, item, options)(fetch, basePath);
        },
        /**
         * Delete trip's checklist
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklist(tripId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).deleteTripChecklist(tripId, options)(fetch, basePath);
        },
        /**
         * Delete a checklist category
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklistCategory(tripId: string, categoryId: number, options?: any) {
            return MyTripChecklistApiFp(configuration).deleteTripChecklistCategory(tripId, categoryId, options)(fetch, basePath);
        },
        /**
         * Delete a checklist item
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripChecklistItem(tripId: string, itemId: number, options?: any) {
            return MyTripChecklistApiFp(configuration).deleteTripChecklistItem(tripId, itemId, options)(fetch, basePath);
        },
        /**
         * Get trip's checklist
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklist(tripId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).getTripChecklist(tripId, options)(fetch, basePath);
        },
        /**
         * Get trip's checklist by share id
         * @param {string} shareId share_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistByShareId(shareId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).getTripChecklistByShareId(shareId, options)(fetch, basePath);
        },
        /**
         * Get trip's checklist categories
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistCategories(tripId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).getTripChecklistCategories(tripId, options)(fetch, basePath);
        },
        /**
         * Get trip's checklist filters
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistFilters(tripId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).getTripChecklistFilters(tripId, options)(fetch, basePath);
        },
        /**
         * Get trip's checklist item counts
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripChecklistItemsCount(tripId: string, options?: any) {
            return MyTripChecklistApiFp(configuration).getTripChecklistItemsCount(tripId, options)(fetch, basePath);
        },
        /**
         * Move checklist item to another category
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {number} categoryId category_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTripCheckListItemToCategory(tripId: string, itemId: number, categoryId: number, dummyBody: any, options?: any) {
            return MyTripChecklistApiFp(configuration).moveTripCheckListItemToCategory(tripId, itemId, categoryId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Reorder checklist categories
         * @param {string} tripId trip_id
         * @param {any} reorderedCategories reorderedCategories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderTripChecklistCategories(tripId: string, reorderedCategories: any, options?: any) {
            return MyTripChecklistApiFp(configuration).reorderTripChecklistCategories(tripId, reorderedCategories, options)(fetch, basePath);
        },
        /**
         * Reorder checklist items
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {any} reorderedItems reorderedItems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderTripChecklistCategoryItems(tripId: string, categoryId: number, reorderedItems: any, options?: any) {
            return MyTripChecklistApiFp(configuration).reorderTripChecklistCategoryItems(tripId, categoryId, reorderedItems, options)(fetch, basePath);
        },
        /**
         * Create predefined checklist for an existing trip, through the predefined templates in the filter service.
         * @param {string} tripId trip_id
         * @param {string} templateId template_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTripPredefinedChecklist(tripId: string, templateId: string, dummyBody: any, options?: any) {
            return MyTripChecklistApiFp(configuration).setTripPredefinedChecklist(tripId, templateId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Creates a new checklist for an existing trip from a user defined checklist template.
         * @param {string} tripId trip_id
         * @param {string} templateTripId template_trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTripUserdefinedChecklist(tripId: string, templateTripId: string, dummyBody: any, options?: any) {
            return MyTripChecklistApiFp(configuration).setTripUserdefinedChecklist(tripId, templateTripId, dummyBody, options)(fetch, basePath);
        },
        /**
         * unassigns a list participant from the item (item handler)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignItemHandler(tripId: string, itemId: number, options?: any) {
            return MyTripChecklistApiFp(configuration).unassignItemHandler(tripId, itemId, options)(fetch, basePath);
        },
        /**
         * Uncheck all checklist items
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncheckAllTripChecklistItems(tripId: string, dummyBody: any, options?: any) {
            return MyTripChecklistApiFp(configuration).uncheckAllTripChecklistItems(tripId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Uncheck multiple items by ids
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklistDto checklistDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncheckTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options?: any) {
            return MyTripChecklistApiFp(configuration).uncheckTripChecklistItems(tripId, checklistDto, options)(fetch, basePath);
        },
        /**
         * Update trip's checklist
         * @param {string} tripId trip_id
         * @param {ChecklistDto} checklist checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklist(tripId: string, checklist: ChecklistDto, options?: any) {
            return MyTripChecklistApiFp(configuration).updateTripChecklist(tripId, checklist, options)(fetch, basePath);
        },
        /**
         * Update a checklist category
         * @param {string} tripId trip_id
         * @param {number} categoryId category_id
         * @param {ChecklistCategoryDto} category category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistCategory(tripId: string, categoryId: number, category: ChecklistCategoryDto, options?: any) {
            return MyTripChecklistApiFp(configuration).updateTripChecklistCategory(tripId, categoryId, category, options)(fetch, basePath);
        },
        /**
         * Update trip's checklist item
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemDto} item item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItem(tripId: string, itemId: number, item: ChecklistItemDto, options?: any) {
            return MyTripChecklistApiFp(configuration).updateTripChecklistItem(tripId, itemId, item, options)(fetch, basePath);
        },
        /**
         * Update a checklist item's state (checked/unchecked)
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemStateDto} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItemState(tripId: string, itemId: number, state: ChecklistItemStateDto, options?: any) {
            return MyTripChecklistApiFp(configuration).updateTripChecklistItemState(tripId, itemId, state, options)(fetch, basePath);
        },
        /**
         * Update the trip's checklist item's tags properties
         * @param {string} tripId trip_id
         * @param {number} itemId item_id
         * @param {ChecklistItemTagDto} tag tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripChecklistItemTag(tripId: string, itemId: number, tag: ChecklistItemTagDto, options?: any) {
            return MyTripChecklistApiFp(configuration).updateTripChecklistItemTag(tripId, itemId, tag, options)(fetch, basePath);
        },
    };
};

/**
 * MyTripChecklistApi - object-oriented interface
 * @export
 * @class MyTripChecklistApi
 * @extends {BaseAPI}
 */
export class MyTripChecklistApi extends BaseAPI {
    /**
     * Assigns an item to a list participant (item handler)
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {} [handler] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public assignItemHandler(tripId: string, itemId: number, handler?: ParticipantDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).assignItemHandler(tripId, itemId, handler, options)(this.fetch, this.basePath);
    }

    /**
     * Check all checklist items
     * @param {} tripId trip_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public checkAllTripChecklistItems(tripId: string, dummyBody: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).checkAllTripChecklistItems(tripId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Check multiple items by ids
     * @param {} tripId trip_id
     * @param {} checklistDto checklistDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public checkTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).checkTripChecklistItems(tripId, checklistDto, options)(this.fetch, this.basePath);
    }

    /**
     * createChecklistPdf
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public createChecklistPdf(tripId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).createChecklistPdf(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Create a checklist for a trip
     * @param {} tripId trip_id
     * @param {} checklist checklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public createTripChecklist(tripId: string, checklist: ChecklistDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).createTripChecklist(tripId, checklist, options)(this.fetch, this.basePath);
    }

    /**
     * Create a checklist category
     * @param {} tripId trip_id
     * @param {} category category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public createTripChecklistCategory(tripId: string, category: ChecklistCategoryDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).createTripChecklistCategory(tripId, category, options)(this.fetch, this.basePath);
    }

    /**
     * Create a checklist item for a trip
     * @param {} tripId trip_id
     * @param {} item item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public createTripChecklistItem(tripId: string, item: ChecklistItemDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).createTripChecklistItem(tripId, item, options)(this.fetch, this.basePath);
    }

    /**
     * Delete trip's checklist
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public deleteTripChecklist(tripId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).deleteTripChecklist(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Delete a checklist category
     * @param {} tripId trip_id
     * @param {} categoryId category_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public deleteTripChecklistCategory(tripId: string, categoryId: number, options?: any) {
        return MyTripChecklistApiFp(this.configuration).deleteTripChecklistCategory(tripId, categoryId, options)(this.fetch, this.basePath);
    }

    /**
     * Delete a checklist item
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public deleteTripChecklistItem(tripId: string, itemId: number, options?: any) {
        return MyTripChecklistApiFp(this.configuration).deleteTripChecklistItem(tripId, itemId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip's checklist
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public getTripChecklist(tripId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).getTripChecklist(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip's checklist by share id
     * @param {} shareId share_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public getTripChecklistByShareId(shareId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).getTripChecklistByShareId(shareId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip's checklist categories
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public getTripChecklistCategories(tripId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).getTripChecklistCategories(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip's checklist filters
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public getTripChecklistFilters(tripId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).getTripChecklistFilters(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip's checklist item counts
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public getTripChecklistItemsCount(tripId: string, options?: any) {
        return MyTripChecklistApiFp(this.configuration).getTripChecklistItemsCount(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Move checklist item to another category
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {} categoryId category_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public moveTripCheckListItemToCategory(tripId: string, itemId: number, categoryId: number, dummyBody: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).moveTripCheckListItemToCategory(tripId, itemId, categoryId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Reorder checklist categories
     * @param {} tripId trip_id
     * @param {} reorderedCategories reorderedCategories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public reorderTripChecklistCategories(tripId: string, reorderedCategories: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).reorderTripChecklistCategories(tripId, reorderedCategories, options)(this.fetch, this.basePath);
    }

    /**
     * Reorder checklist items
     * @param {} tripId trip_id
     * @param {} categoryId category_id
     * @param {} reorderedItems reorderedItems
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public reorderTripChecklistCategoryItems(tripId: string, categoryId: number, reorderedItems: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).reorderTripChecklistCategoryItems(tripId, categoryId, reorderedItems, options)(this.fetch, this.basePath);
    }

    /**
     * Create predefined checklist for an existing trip, through the predefined templates in the filter service.
     * @param {} tripId trip_id
     * @param {} templateId template_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public setTripPredefinedChecklist(tripId: string, templateId: string, dummyBody: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).setTripPredefinedChecklist(tripId, templateId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Creates a new checklist for an existing trip from a user defined checklist template.
     * @param {} tripId trip_id
     * @param {} templateTripId template_trip_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public setTripUserdefinedChecklist(tripId: string, templateTripId: string, dummyBody: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).setTripUserdefinedChecklist(tripId, templateTripId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * unassigns a list participant from the item (item handler)
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public unassignItemHandler(tripId: string, itemId: number, options?: any) {
        return MyTripChecklistApiFp(this.configuration).unassignItemHandler(tripId, itemId, options)(this.fetch, this.basePath);
    }

    /**
     * Uncheck all checklist items
     * @param {} tripId trip_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public uncheckAllTripChecklistItems(tripId: string, dummyBody: any, options?: any) {
        return MyTripChecklistApiFp(this.configuration).uncheckAllTripChecklistItems(tripId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Uncheck multiple items by ids
     * @param {} tripId trip_id
     * @param {} checklistDto checklistDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public uncheckTripChecklistItems(tripId: string, checklistDto: ChecklistDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).uncheckTripChecklistItems(tripId, checklistDto, options)(this.fetch, this.basePath);
    }

    /**
     * Update trip's checklist
     * @param {} tripId trip_id
     * @param {} checklist checklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public updateTripChecklist(tripId: string, checklist: ChecklistDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).updateTripChecklist(tripId, checklist, options)(this.fetch, this.basePath);
    }

    /**
     * Update a checklist category
     * @param {} tripId trip_id
     * @param {} categoryId category_id
     * @param {} category category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public updateTripChecklistCategory(tripId: string, categoryId: number, category: ChecklistCategoryDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).updateTripChecklistCategory(tripId, categoryId, category, options)(this.fetch, this.basePath);
    }

    /**
     * Update trip's checklist item
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {} item item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public updateTripChecklistItem(tripId: string, itemId: number, item: ChecklistItemDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).updateTripChecklistItem(tripId, itemId, item, options)(this.fetch, this.basePath);
    }

    /**
     * Update a checklist item's state (checked/unchecked)
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {} state state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public updateTripChecklistItemState(tripId: string, itemId: number, state: ChecklistItemStateDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).updateTripChecklistItemState(tripId, itemId, state, options)(this.fetch, this.basePath);
    }

    /**
     * Update the trip's checklist item's tags properties
     * @param {} tripId trip_id
     * @param {} itemId item_id
     * @param {} tag tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripChecklistApi
     */
    public updateTripChecklistItemTag(tripId: string, itemId: number, tag: ChecklistItemTagDto, options?: any) {
        return MyTripChecklistApiFp(this.configuration).updateTripChecklistItemTag(tripId, itemId, tag, options)(this.fetch, this.basePath);
    }

}

/**
 * MyTripNotificationsApi - fetch parameter creator
 * @export
 */
export const MyTripNotificationsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a trip's notification
         * @param {string} tripId trip_id
         * @param {NotificationDto} notification The notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripNotification(tripId: string, notification: NotificationDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createTripNotification.');
            }
            // verify required parameter 'notification' is not null or undefined
            if (notification === null || notification === undefined) {
                throw new RequiredError('notification','Required parameter notification was null or undefined when calling createTripNotification.');
            }
            const localVarPath = `/trips/{trip_id}/notfificatons`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notification || {}) : (notification || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a trip's notification
         * @param {string} tripId trip_id
         * @param {number} notificationId notification_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripNotification(tripId: string, notificationId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTripNotification.');
            }
            // verify required parameter 'notificationId' is not null or undefined
            if (notificationId === null || notificationId === undefined) {
                throw new RequiredError('notificationId','Required parameter notificationId was null or undefined when calling deleteTripNotification.');
            }
            const localVarPath = `/trips/{trip_id}/notfificatons/{notification_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the trip's notification
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripNotifications(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripNotifications.');
            }
            const localVarPath = `/trips/{trip_id}/notfificatons`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a trip's notification
         * @param {string} tripId trip_id
         * @param {number} notificationId notification_id
         * @param {NotificationDto} notification notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripNotification(tripId: string, notificationId: number, notification: NotificationDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTripNotification.');
            }
            // verify required parameter 'notificationId' is not null or undefined
            if (notificationId === null || notificationId === undefined) {
                throw new RequiredError('notificationId','Required parameter notificationId was null or undefined when calling updateTripNotification.');
            }
            // verify required parameter 'notification' is not null or undefined
            if (notification === null || notification === undefined) {
                throw new RequiredError('notification','Required parameter notification was null or undefined when calling updateTripNotification.');
            }
            const localVarPath = `/trips/{trip_id}/notfificatons/{notification_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notification || {}) : (notification || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyTripNotificationsApi - functional programming interface
 * @export
 */
export const MyTripNotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a trip's notification
         * @param {string} tripId trip_id
         * @param {NotificationDto} notification The notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripNotification(tripId: string, notification: NotificationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperNotificationDto> {
            const localVarFetchArgs = MyTripNotificationsApiFetchParamCreator(configuration).createTripNotification(tripId, notification, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete a trip's notification
         * @param {string} tripId trip_id
         * @param {number} notificationId notification_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripNotification(tripId: string, notificationId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripNotificationsApiFetchParamCreator(configuration).deleteTripNotification(tripId, notificationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get the trip's notification
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripNotifications(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListNotificationDto> {
            const localVarFetchArgs = MyTripNotificationsApiFetchParamCreator(configuration).getTripNotifications(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update a trip's notification
         * @param {string} tripId trip_id
         * @param {number} notificationId notification_id
         * @param {NotificationDto} notification notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripNotification(tripId: string, notificationId: number, notification: NotificationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperNotificationDto> {
            const localVarFetchArgs = MyTripNotificationsApiFetchParamCreator(configuration).updateTripNotification(tripId, notificationId, notification, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MyTripNotificationsApi - factory interface
 * @export
 */
export const MyTripNotificationsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Create a trip's notification
         * @param {string} tripId trip_id
         * @param {NotificationDto} notification The notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripNotification(tripId: string, notification: NotificationDto, options?: any) {
            return MyTripNotificationsApiFp(configuration).createTripNotification(tripId, notification, options)(fetch, basePath);
        },
        /**
         * Delete a trip's notification
         * @param {string} tripId trip_id
         * @param {number} notificationId notification_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripNotification(tripId: string, notificationId: number, options?: any) {
            return MyTripNotificationsApiFp(configuration).deleteTripNotification(tripId, notificationId, options)(fetch, basePath);
        },
        /**
         * Get the trip's notification
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripNotifications(tripId: string, options?: any) {
            return MyTripNotificationsApiFp(configuration).getTripNotifications(tripId, options)(fetch, basePath);
        },
        /**
         * Update a trip's notification
         * @param {string} tripId trip_id
         * @param {number} notificationId notification_id
         * @param {NotificationDto} notification notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripNotification(tripId: string, notificationId: number, notification: NotificationDto, options?: any) {
            return MyTripNotificationsApiFp(configuration).updateTripNotification(tripId, notificationId, notification, options)(fetch, basePath);
        },
    };
};

/**
 * MyTripNotificationsApi - object-oriented interface
 * @export
 * @class MyTripNotificationsApi
 * @extends {BaseAPI}
 */
export class MyTripNotificationsApi extends BaseAPI {
    /**
     * Create a trip's notification
     * @param {} tripId trip_id
     * @param {} notification The notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripNotificationsApi
     */
    public createTripNotification(tripId: string, notification: NotificationDto, options?: any) {
        return MyTripNotificationsApiFp(this.configuration).createTripNotification(tripId, notification, options)(this.fetch, this.basePath);
    }

    /**
     * Delete a trip's notification
     * @param {} tripId trip_id
     * @param {} notificationId notification_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripNotificationsApi
     */
    public deleteTripNotification(tripId: string, notificationId: number, options?: any) {
        return MyTripNotificationsApiFp(this.configuration).deleteTripNotification(tripId, notificationId, options)(this.fetch, this.basePath);
    }

    /**
     * Get the trip's notification
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripNotificationsApi
     */
    public getTripNotifications(tripId: string, options?: any) {
        return MyTripNotificationsApiFp(this.configuration).getTripNotifications(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Update a trip's notification
     * @param {} tripId trip_id
     * @param {} notificationId notification_id
     * @param {} notification notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripNotificationsApi
     */
    public updateTripNotification(tripId: string, notificationId: number, notification: NotificationDto, options?: any) {
        return MyTripNotificationsApiFp(this.configuration).updateTripNotification(tripId, notificationId, notification, options)(this.fetch, this.basePath);
    }

}

/**
 * MyTripParticipantsApi - fetch parameter creator
 * @export
 */
export const MyTripParticipantsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds particpant to trip. Returns HTTP status 409 Conflict if participant already exists.
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTripParticipant(tripId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling addTripParticipant.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling addTripParticipant.');
            }
            const localVarPath = `/trips/{trip_id}/participants`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a particpant from a trip. List owners can not be deleted
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripParticipant(tripId: string, participantId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTripParticipant.');
            }
            // verify required parameter 'participantId' is not null or undefined
            if (participantId === null || participantId === undefined) {
                throw new RequiredError('participantId','Required parameter participantId was null or undefined when calling deleteTripParticipant.');
            }
            const localVarPath = `/trips/{trip_id}/participants/{participant_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"participant_id"}}`, encodeURIComponent(String(participantId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a trip's particpant. e.g the notificationsViewedDate
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {ParticipantDto} participant the updated participant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTripParticipant(tripId: string, participantId: number, participant: ParticipantDto, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling editTripParticipant.');
            }
            // verify required parameter 'participantId' is not null or undefined
            if (participantId === null || participantId === undefined) {
                throw new RequiredError('participantId','Required parameter participantId was null or undefined when calling editTripParticipant.');
            }
            // verify required parameter 'participant' is not null or undefined
            if (participant === null || participant === undefined) {
                throw new RequiredError('participant','Required parameter participant was null or undefined when calling editTripParticipant.');
            }
            const localVarPath = `/trips/{trip_id}/participants/{participant_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"participant_id"}}`, encodeURIComponent(String(participantId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ParticipantDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(participant || {}) : (participant || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a trip participant.
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripParticipant(tripId: string, participantId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripParticipant.');
            }
            // verify required parameter 'participantId' is not null or undefined
            if (participantId === null || participantId === undefined) {
                throw new RequiredError('participantId','Required parameter participantId was null or undefined when calling getTripParticipant.');
            }
            const localVarPath = `/trips/{trip_id}/participants/{participant_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"participant_id"}}`, encodeURIComponent(String(participantId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all trip participants
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripParticipants(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripParticipants.');
            }
            const localVarPath = `/trips/{trip_id}/participants`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyTripParticipantsApi - functional programming interface
 * @export
 */
export const MyTripParticipantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Adds particpant to trip. Returns HTTP status 409 Conflict if participant already exists.
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTripParticipant(tripId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperParticipantDto> {
            const localVarFetchArgs = MyTripParticipantsApiFetchParamCreator(configuration).addTripParticipant(tripId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes a particpant from a trip. List owners can not be deleted
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripParticipant(tripId: string, participantId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripParticipantsApiFetchParamCreator(configuration).deleteTripParticipant(tripId, participantId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates a trip's particpant. e.g the notificationsViewedDate
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {ParticipantDto} participant the updated participant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTripParticipant(tripId: string, participantId: number, participant: ParticipantDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperParticipantDto> {
            const localVarFetchArgs = MyTripParticipantsApiFetchParamCreator(configuration).editTripParticipant(tripId, participantId, participant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets a trip participant.
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripParticipant(tripId: string, participantId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperParticipantDto> {
            const localVarFetchArgs = MyTripParticipantsApiFetchParamCreator(configuration).getTripParticipant(tripId, participantId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets all trip participants
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripParticipants(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListParticipantDto> {
            const localVarFetchArgs = MyTripParticipantsApiFetchParamCreator(configuration).getTripParticipants(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MyTripParticipantsApi - factory interface
 * @export
 */
export const MyTripParticipantsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Adds particpant to trip. Returns HTTP status 409 Conflict if participant already exists.
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTripParticipant(tripId: string, dummyBody: any, options?: any) {
            return MyTripParticipantsApiFp(configuration).addTripParticipant(tripId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Removes a particpant from a trip. List owners can not be deleted
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripParticipant(tripId: string, participantId: number, options?: any) {
            return MyTripParticipantsApiFp(configuration).deleteTripParticipant(tripId, participantId, options)(fetch, basePath);
        },
        /**
         * Updates a trip's particpant. e.g the notificationsViewedDate
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {ParticipantDto} participant the updated participant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTripParticipant(tripId: string, participantId: number, participant: ParticipantDto, options?: any) {
            return MyTripParticipantsApiFp(configuration).editTripParticipant(tripId, participantId, participant, options)(fetch, basePath);
        },
        /**
         * Gets a trip participant.
         * @param {string} tripId trip_id
         * @param {number} participantId participant_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripParticipant(tripId: string, participantId: number, options?: any) {
            return MyTripParticipantsApiFp(configuration).getTripParticipant(tripId, participantId, options)(fetch, basePath);
        },
        /**
         * Gets all trip participants
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripParticipants(tripId: string, options?: any) {
            return MyTripParticipantsApiFp(configuration).getTripParticipants(tripId, options)(fetch, basePath);
        },
    };
};

/**
 * MyTripParticipantsApi - object-oriented interface
 * @export
 * @class MyTripParticipantsApi
 * @extends {BaseAPI}
 */
export class MyTripParticipantsApi extends BaseAPI {
    /**
     * Adds particpant to trip. Returns HTTP status 409 Conflict if participant already exists.
     * @param {} tripId trip_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripParticipantsApi
     */
    public addTripParticipant(tripId: string, dummyBody: any, options?: any) {
        return MyTripParticipantsApiFp(this.configuration).addTripParticipant(tripId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Removes a particpant from a trip. List owners can not be deleted
     * @param {} tripId trip_id
     * @param {} participantId participant_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripParticipantsApi
     */
    public deleteTripParticipant(tripId: string, participantId: number, options?: any) {
        return MyTripParticipantsApiFp(this.configuration).deleteTripParticipant(tripId, participantId, options)(this.fetch, this.basePath);
    }

    /**
     * Updates a trip's particpant. e.g the notificationsViewedDate
     * @param {} tripId trip_id
     * @param {} participantId participant_id
     * @param {} participant the updated participant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripParticipantsApi
     */
    public editTripParticipant(tripId: string, participantId: number, participant: ParticipantDto, options?: any) {
        return MyTripParticipantsApiFp(this.configuration).editTripParticipant(tripId, participantId, participant, options)(this.fetch, this.basePath);
    }

    /**
     * Gets a trip participant.
     * @param {} tripId trip_id
     * @param {} participantId participant_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripParticipantsApi
     */
    public getTripParticipant(tripId: string, participantId: number, options?: any) {
        return MyTripParticipantsApiFp(this.configuration).getTripParticipant(tripId, participantId, options)(this.fetch, this.basePath);
    }

    /**
     * Gets all trip participants
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripParticipantsApi
     */
    public getTripParticipants(tripId: string, options?: any) {
        return MyTripParticipantsApiFp(this.configuration).getTripParticipants(tripId, options)(this.fetch, this.basePath);
    }

}

/**
 * MyTripPicturesApi - fetch parameter creator
 * @export
 */
export const MyTripPicturesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get trip pictures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripPictures(options: any = {}): FetchArgs {
            const localVarPath = `/pictures`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload files
         * @param {UploadDto} uploadDto UploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPicture(uploadDto: UploadDto, options: any = {}): FetchArgs {
            // verify required parameter 'uploadDto' is not null or undefined
            if (uploadDto === null || uploadDto === undefined) {
                throw new RequiredError('uploadDto','Required parameter uploadDto was null or undefined when calling uploadPicture.');
            }
            const localVarPath = `/uploads`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UploadDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uploadDto || {}) : (uploadDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyTripPicturesApi - functional programming interface
 * @export
 */
export const MyTripPicturesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get trip pictures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripPictures(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListTripPictureDto> {
            const localVarFetchArgs = MyTripPicturesApiFetchParamCreator(configuration).getTripPictures(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Upload files
         * @param {UploadDto} uploadDto UploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPicture(uploadDto: UploadDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = MyTripPicturesApiFetchParamCreator(configuration).uploadPicture(uploadDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MyTripPicturesApi - factory interface
 * @export
 */
export const MyTripPicturesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get trip pictures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripPictures(options?: any) {
            return MyTripPicturesApiFp(configuration).getTripPictures(options)(fetch, basePath);
        },
        /**
         * Upload files
         * @param {UploadDto} uploadDto UploadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPicture(uploadDto: UploadDto, options?: any) {
            return MyTripPicturesApiFp(configuration).uploadPicture(uploadDto, options)(fetch, basePath);
        },
    };
};

/**
 * MyTripPicturesApi - object-oriented interface
 * @export
 * @class MyTripPicturesApi
 * @extends {BaseAPI}
 */
export class MyTripPicturesApi extends BaseAPI {
    /**
     * Get trip pictures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripPicturesApi
     */
    public getTripPictures(options?: any) {
        return MyTripPicturesApiFp(this.configuration).getTripPictures(options)(this.fetch, this.basePath);
    }

    /**
     * Upload files
     * @param {} uploadDto UploadDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripPicturesApi
     */
    public uploadPicture(uploadDto: UploadDto, options?: any) {
        return MyTripPicturesApiFp(this.configuration).uploadPicture(uploadDto, options)(this.fetch, this.basePath);
    }

}

/**
 * MyTripsApi - fetch parameter creator
 * @export
 */
export const MyTripsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if trip exists
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfTripExists(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling checkIfTripExists.');
            }
            const localVarPath = `/trips/{trip_id}/check`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Copy an existing trip
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTrip(tripId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling copyTrip.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling copyTrip.');
            }
            const localVarPath = `/trips/{trip_id}/copyTrip`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create predefined trip, through the predefined templates in the filter service
         * @param {string} templateId template_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedTrip(templateId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new RequiredError('templateId','Required parameter templateId was null or undefined when calling createPredefinedTrip.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling createPredefinedTrip.');
            }
            const localVarPath = `/trips/predefined/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create trip
         * @param {TripDto} trip trip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(trip: TripDto, options: any = {}): FetchArgs {
            // verify required parameter 'trip' is not null or undefined
            if (trip === null || trip === undefined) {
                throw new RequiredError('trip','Required parameter trip was null or undefined when calling createTrip.');
            }
            const localVarPath = `/trips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TripDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(trip || {}) : (trip || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add destination to trip
         * @param {string} tripId trip_id
         * @param {any} destination destination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripDestination(tripId: string, destination: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createTripDestination.');
            }
            // verify required parameter 'destination' is not null or undefined
            if (destination === null || destination === undefined) {
                throw new RequiredError('destination','Required parameter destination was null or undefined when calling createTripDestination.');
            }
            const localVarPath = `/trips/{trip_id}/destinations`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(destination || {}) : (destination || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new user checklist template
         * @param {UserTemplateDto} userTemplate A user checklist template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserTemplate(userTemplate: UserTemplateDto, options: any = {}): FetchArgs {
            // verify required parameter 'userTemplate' is not null or undefined
            if (userTemplate === null || userTemplate === undefined) {
                throw new RequiredError('userTemplate','Required parameter userTemplate was null or undefined when calling createUserTemplate.');
            }
            const localVarPath = `/templates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserTemplateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(userTemplate || {}) : (userTemplate || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new trip from a user defined checklist template
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserdefinedTrip(tripId: string, dummyBody: any, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling createUserdefinedTrip.');
            }
            // verify required parameter 'dummyBody' is not null or undefined
            if (dummyBody === null || dummyBody === undefined) {
                throw new RequiredError('dummyBody','Required parameter dummyBody was null or undefined when calling createUserdefinedTrip.');
            }
            const localVarPath = `/trips/userdefined/{trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"any" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(dummyBody || {}) : (dummyBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete trip by id
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTrip.');
            }
            const localVarPath = `/trips/{trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete destination from a trip
         * @param {string} tripId trip_id
         * @param {string} destinationId destination_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripDestination(tripId: string, destinationId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteTripDestination.');
            }
            // verify required parameter 'destinationId' is not null or undefined
            if (destinationId === null || destinationId === undefined) {
                throw new RequiredError('destinationId','Required parameter destinationId was null or undefined when calling deleteTripDestination.');
            }
            const localVarPath = `/trips/{trip_id}/destinations/{destination_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)))
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a user checklist template
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTemplate(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling deleteUserTemplate.');
            }
            const localVarPath = `/templates/{trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all users trips with checklists, regardless if they are created in web or app.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTrips(options: any = {}): FetchArgs {
            const localVarPath = `/checklisttrips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Map anonymous trip
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateAnonymousTripById(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getOrCreateAnonymousTripById.');
            }
            const localVarPath = `/temptrip/{trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip by id
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripById(tripId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling getTripById.');
            }
            const localVarPath = `/trips/{trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trip by share id
         * @param {string} shareId share_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripByShareId(shareId: string, options: any = {}): FetchArgs {
            // verify required parameter 'shareId' is not null or undefined
            if (shareId === null || shareId === undefined) {
                throw new RequiredError('shareId','Required parameter shareId was null or undefined when calling getTripByShareId.');
            }
            const localVarPath = `/shared/trips/{share_id}`
                .replace(`{${"share_id"}}`, encodeURIComponent(String(shareId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current users trips
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrips(options: any = {}): FetchArgs {
            const localVarPath = `/trips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current users trips, that are undefined (have no dates)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUndefinedTrips(options: any = {}): FetchArgs {
            const localVarPath = `/undefinedtrips`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all user checklist templates for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTemplates(options: any = {}): FetchArgs {
            const localVarPath = `/templates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update trip
         * @param {string} tripId trip_id
         * @param {TripDto} trip trip
         * @param {string} [shareType] Share all or one categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrip(tripId: string, trip: TripDto, shareType?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tripId' is not null or undefined
            if (tripId === null || tripId === undefined) {
                throw new RequiredError('tripId','Required parameter tripId was null or undefined when calling updateTrip.');
            }
            // verify required parameter 'trip' is not null or undefined
            if (trip === null || trip === undefined) {
                throw new RequiredError('trip','Required parameter trip was null or undefined when calling updateTrip.');
            }
            const localVarPath = `/trips/{trip_id}`
                .replace(`{${"trip_id"}}`, encodeURIComponent(String(tripId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shareType !== undefined) {
                localVarQueryParameter['shareType'] = shareType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TripDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(trip || {}) : (trip || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyTripsApi - functional programming interface
 * @export
 */
export const MyTripsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Check if trip exists
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfTripExists(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).checkIfTripExists(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Copy an existing trip
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTrip(tripId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).copyTrip(tripId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create predefined trip, through the predefined templates in the filter service
         * @param {string} templateId template_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedTrip(templateId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).createPredefinedTrip(templateId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Create trip
         * @param {TripDto} trip trip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(trip: TripDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).createTrip(trip, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add destination to trip
         * @param {string} tripId trip_id
         * @param {any} destination destination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripDestination(tripId: string, destination: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).createTripDestination(tripId, destination, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates a new user checklist template
         * @param {UserTemplateDto} userTemplate A user checklist template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserTemplate(userTemplate: UserTemplateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperUserTemplateDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).createUserTemplate(userTemplate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates a new trip from a user defined checklist template
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserdefinedTrip(tripId: string, dummyBody: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperChecklistDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).createUserdefinedTrip(tripId, dummyBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete trip by id
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).deleteTrip(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Delete destination from a trip
         * @param {string} tripId trip_id
         * @param {string} destinationId destination_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripDestination(tripId: string, destinationId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).deleteTripDestination(tripId, destinationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes a user checklist template
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTemplate(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).deleteUserTemplate(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get all users trips with checklists, regardless if they are created in web or app.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTrips(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getChecklistTrips(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Map anonymous trip
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateAnonymousTripById(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getOrCreateAnonymousTripById(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip by id
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripById(tripId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getTripById(tripId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get trip by share id
         * @param {string} shareId share_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripByShareId(shareId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getTripByShareId(shareId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get current users trips
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrips(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getTrips(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get current users trips, that are undefined (have no dates)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUndefinedTrips(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getUndefinedTrips(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Gets all user checklist templates for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTemplates(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListUserTemplateDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).getUserTemplates(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update trip
         * @param {string} tripId trip_id
         * @param {TripDto} trip trip
         * @param {string} [shareType] Share all or one categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrip(tripId: string, trip: TripDto, shareType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTripDto> {
            const localVarFetchArgs = MyTripsApiFetchParamCreator(configuration).updateTrip(tripId, trip, shareType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MyTripsApi - factory interface
 * @export
 */
export const MyTripsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Check if trip exists
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfTripExists(tripId: string, options?: any) {
            return MyTripsApiFp(configuration).checkIfTripExists(tripId, options)(fetch, basePath);
        },
        /**
         * Copy an existing trip
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTrip(tripId: string, dummyBody: any, options?: any) {
            return MyTripsApiFp(configuration).copyTrip(tripId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Create predefined trip, through the predefined templates in the filter service
         * @param {string} templateId template_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedTrip(templateId: string, dummyBody: any, options?: any) {
            return MyTripsApiFp(configuration).createPredefinedTrip(templateId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Create trip
         * @param {TripDto} trip trip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(trip: TripDto, options?: any) {
            return MyTripsApiFp(configuration).createTrip(trip, options)(fetch, basePath);
        },
        /**
         * Add destination to trip
         * @param {string} tripId trip_id
         * @param {any} destination destination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripDestination(tripId: string, destination: any, options?: any) {
            return MyTripsApiFp(configuration).createTripDestination(tripId, destination, options)(fetch, basePath);
        },
        /**
         * Creates a new user checklist template
         * @param {UserTemplateDto} userTemplate A user checklist template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserTemplate(userTemplate: UserTemplateDto, options?: any) {
            return MyTripsApiFp(configuration).createUserTemplate(userTemplate, options)(fetch, basePath);
        },
        /**
         * Creates a new trip from a user defined checklist template
         * @param {string} tripId trip_id
         * @param {any} dummyBody an empty dummy object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserdefinedTrip(tripId: string, dummyBody: any, options?: any) {
            return MyTripsApiFp(configuration).createUserdefinedTrip(tripId, dummyBody, options)(fetch, basePath);
        },
        /**
         * Delete trip by id
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(tripId: string, options?: any) {
            return MyTripsApiFp(configuration).deleteTrip(tripId, options)(fetch, basePath);
        },
        /**
         * Delete destination from a trip
         * @param {string} tripId trip_id
         * @param {string} destinationId destination_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripDestination(tripId: string, destinationId: string, options?: any) {
            return MyTripsApiFp(configuration).deleteTripDestination(tripId, destinationId, options)(fetch, basePath);
        },
        /**
         * Deletes a user checklist template
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTemplate(tripId: string, options?: any) {
            return MyTripsApiFp(configuration).deleteUserTemplate(tripId, options)(fetch, basePath);
        },
        /**
         * Get all users trips with checklists, regardless if they are created in web or app.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTrips(options?: any) {
            return MyTripsApiFp(configuration).getChecklistTrips(options)(fetch, basePath);
        },
        /**
         * Map anonymous trip
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateAnonymousTripById(tripId: string, options?: any) {
            return MyTripsApiFp(configuration).getOrCreateAnonymousTripById(tripId, options)(fetch, basePath);
        },
        /**
         * Get trip by id
         * @param {string} tripId trip_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripById(tripId: string, options?: any) {
            return MyTripsApiFp(configuration).getTripById(tripId, options)(fetch, basePath);
        },
        /**
         * Get trip by share id
         * @param {string} shareId share_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripByShareId(shareId: string, options?: any) {
            return MyTripsApiFp(configuration).getTripByShareId(shareId, options)(fetch, basePath);
        },
        /**
         * Get current users trips
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrips(options?: any) {
            return MyTripsApiFp(configuration).getTrips(options)(fetch, basePath);
        },
        /**
         * Get current users trips, that are undefined (have no dates)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUndefinedTrips(options?: any) {
            return MyTripsApiFp(configuration).getUndefinedTrips(options)(fetch, basePath);
        },
        /**
         * Gets all user checklist templates for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTemplates(options?: any) {
            return MyTripsApiFp(configuration).getUserTemplates(options)(fetch, basePath);
        },
        /**
         * Update trip
         * @param {string} tripId trip_id
         * @param {TripDto} trip trip
         * @param {string} [shareType] Share all or one categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrip(tripId: string, trip: TripDto, shareType?: string, options?: any) {
            return MyTripsApiFp(configuration).updateTrip(tripId, trip, shareType, options)(fetch, basePath);
        },
    };
};

/**
 * MyTripsApi - object-oriented interface
 * @export
 * @class MyTripsApi
 * @extends {BaseAPI}
 */
export class MyTripsApi extends BaseAPI {
    /**
     * Check if trip exists
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public checkIfTripExists(tripId: string, options?: any) {
        return MyTripsApiFp(this.configuration).checkIfTripExists(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Copy an existing trip
     * @param {} tripId trip_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public copyTrip(tripId: string, dummyBody: any, options?: any) {
        return MyTripsApiFp(this.configuration).copyTrip(tripId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Create predefined trip, through the predefined templates in the filter service
     * @param {} templateId template_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public createPredefinedTrip(templateId: string, dummyBody: any, options?: any) {
        return MyTripsApiFp(this.configuration).createPredefinedTrip(templateId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Create trip
     * @param {} trip trip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public createTrip(trip: TripDto, options?: any) {
        return MyTripsApiFp(this.configuration).createTrip(trip, options)(this.fetch, this.basePath);
    }

    /**
     * Add destination to trip
     * @param {} tripId trip_id
     * @param {} destination destination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public createTripDestination(tripId: string, destination: any, options?: any) {
        return MyTripsApiFp(this.configuration).createTripDestination(tripId, destination, options)(this.fetch, this.basePath);
    }

    /**
     * Creates a new user checklist template
     * @param {} userTemplate A user checklist template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public createUserTemplate(userTemplate: UserTemplateDto, options?: any) {
        return MyTripsApiFp(this.configuration).createUserTemplate(userTemplate, options)(this.fetch, this.basePath);
    }

    /**
     * Creates a new trip from a user defined checklist template
     * @param {} tripId trip_id
     * @param {} dummyBody an empty dummy object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public createUserdefinedTrip(tripId: string, dummyBody: any, options?: any) {
        return MyTripsApiFp(this.configuration).createUserdefinedTrip(tripId, dummyBody, options)(this.fetch, this.basePath);
    }

    /**
     * Delete trip by id
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public deleteTrip(tripId: string, options?: any) {
        return MyTripsApiFp(this.configuration).deleteTrip(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Delete destination from a trip
     * @param {} tripId trip_id
     * @param {} destinationId destination_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public deleteTripDestination(tripId: string, destinationId: string, options?: any) {
        return MyTripsApiFp(this.configuration).deleteTripDestination(tripId, destinationId, options)(this.fetch, this.basePath);
    }

    /**
     * Deletes a user checklist template
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public deleteUserTemplate(tripId: string, options?: any) {
        return MyTripsApiFp(this.configuration).deleteUserTemplate(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Get all users trips with checklists, regardless if they are created in web or app.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getChecklistTrips(options?: any) {
        return MyTripsApiFp(this.configuration).getChecklistTrips(options)(this.fetch, this.basePath);
    }

    /**
     * Map anonymous trip
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getOrCreateAnonymousTripById(tripId: string, options?: any) {
        return MyTripsApiFp(this.configuration).getOrCreateAnonymousTripById(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip by id
     * @param {} tripId trip_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getTripById(tripId: string, options?: any) {
        return MyTripsApiFp(this.configuration).getTripById(tripId, options)(this.fetch, this.basePath);
    }

    /**
     * Get trip by share id
     * @param {} shareId share_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getTripByShareId(shareId: string, options?: any) {
        return MyTripsApiFp(this.configuration).getTripByShareId(shareId, options)(this.fetch, this.basePath);
    }

    /**
     * Get current users trips
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getTrips(options?: any) {
        return MyTripsApiFp(this.configuration).getTrips(options)(this.fetch, this.basePath);
    }

    /**
     * Get current users trips, that are undefined (have no dates)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getUndefinedTrips(options?: any) {
        return MyTripsApiFp(this.configuration).getUndefinedTrips(options)(this.fetch, this.basePath);
    }

    /**
     * Gets all user checklist templates for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public getUserTemplates(options?: any) {
        return MyTripsApiFp(this.configuration).getUserTemplates(options)(this.fetch, this.basePath);
    }

    /**
     * Update trip
     * @param {} tripId trip_id
     * @param {} trip trip
     * @param {} [shareType] Share all or one categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyTripsApi
     */
    public updateTrip(tripId: string, trip: TripDto, shareType?: string, options?: any) {
        return MyTripsApiFp(this.configuration).updateTrip(tripId, trip, shareType, options)(this.fetch, this.basePath);
    }

}

/**
 * PublicApi - fetch parameter creator
 * @export
 */
export const PublicApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get filter group (required to create a checklist) by name
         * @param {string} name name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterByName(name: string, options: any = {}): FetchArgs {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling getFilterByName.');
            }
            const localVarPath = `/filters/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get filter groups required to create a checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters(options: any = {}): FetchArgs {
            const localVarPath = `/filters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get predefined filter templates (Wellness, Winterurlaub...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates(options: any = {}): FetchArgs {
            const localVarPath = `/filters/templates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 * @export
 */
export const PublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get filter group (required to create a checklist) by name
         * @param {string} name name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterByName(name: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperFilterGroupItemsDto> {
            const localVarFetchArgs = PublicApiFetchParamCreator(configuration).getFilterByName(name, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get filter groups required to create a checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperFilterGroupItemsDto> {
            const localVarFetchArgs = PublicApiFetchParamCreator(configuration).getFilters(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get predefined filter templates (Wellness, Winterurlaub...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperListTemplateDto> {
            const localVarFetchArgs = PublicApiFetchParamCreator(configuration).getTemplates(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PublicApi - factory interface
 * @export
 */
export const PublicApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get filter group (required to create a checklist) by name
         * @param {string} name name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterByName(name: string, options?: any) {
            return PublicApiFp(configuration).getFilterByName(name, options)(fetch, basePath);
        },
        /**
         * Get filter groups required to create a checklist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters(options?: any) {
            return PublicApiFp(configuration).getFilters(options)(fetch, basePath);
        },
        /**
         * Get predefined filter templates (Wellness, Winterurlaub...)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates(options?: any) {
            return PublicApiFp(configuration).getTemplates(options)(fetch, basePath);
        },
    };
};

/**
 * PublicApi - object-oriented interface
 * @export
 * @class PublicApi
 * @extends {BaseAPI}
 */
export class PublicApi extends BaseAPI {
    /**
     * Get filter group (required to create a checklist) by name
     * @param {} name name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public getFilterByName(name: string, options?: any) {
        return PublicApiFp(this.configuration).getFilterByName(name, options)(this.fetch, this.basePath);
    }

    /**
     * Get filter groups required to create a checklist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public getFilters(options?: any) {
        return PublicApiFp(this.configuration).getFilters(options)(this.fetch, this.basePath);
    }

    /**
     * Get predefined filter templates (Wellness, Winterurlaub...)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public getTemplates(options?: any) {
        return PublicApiFp(this.configuration).getTemplates(options)(this.fetch, this.basePath);
    }

}

/**
 * TranslationApi - fetch parameter creator
 * @export
 */
export const TranslationApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * gets a translation definition
         * @param {string} lang an ISO language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslation(lang: string, options: any = {}): FetchArgs {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getTranslation.');
            }
            const localVarPath = `/translations/{lang}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationApi - functional programming interface
 * @export
 */
export const TranslationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * gets a translation definition
         * @param {string} lang an ISO language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslation(lang: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTranslationDto> {
            const localVarFetchArgs = TranslationApiFetchParamCreator(configuration).getTranslation(lang, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TranslationApi - factory interface
 * @export
 */
export const TranslationApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * gets a translation definition
         * @param {string} lang an ISO language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslation(lang: string, options?: any) {
            return TranslationApiFp(configuration).getTranslation(lang, options)(fetch, basePath);
        },
    };
};

/**
 * TranslationApi - object-oriented interface
 * @export
 * @class TranslationApi
 * @extends {BaseAPI}
 */
export class TranslationApi extends BaseAPI {
    /**
     * gets a translation definition
     * @param {} lang an ISO language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationApi
     */
    public getTranslation(lang: string, options?: any) {
        return TranslationApiFp(this.configuration).getTranslation(lang, options)(this.fetch, this.basePath);
    }

}

/**
 * TravelAppConfigApi - fetch parameter creator
 * @export
 */
export const TravelAppConfigApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get the travel app config
         * @param {string} version a version number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelAppConfig(version: string, options: any = {}): FetchArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getTravelAppConfig.');
            }
            const localVarPath = `/travelAppConfig/{version}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TravelAppConfigApi - functional programming interface
 * @export
 */
export const TravelAppConfigApiFp = function(configuration?: Configuration) {
    return {
        /**
         * get the travel app config
         * @param {string} version a version number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelAppConfig(version: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DataWrapperTravelAppConfigDto> {
            const localVarFetchArgs = TravelAppConfigApiFetchParamCreator(configuration).getTravelAppConfig(version, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TravelAppConfigApi - factory interface
 * @export
 */
export const TravelAppConfigApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * get the travel app config
         * @param {string} version a version number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelAppConfig(version: string, options?: any) {
            return TravelAppConfigApiFp(configuration).getTravelAppConfig(version, options)(fetch, basePath);
        },
    };
};

/**
 * TravelAppConfigApi - object-oriented interface
 * @export
 * @class TravelAppConfigApi
 * @extends {BaseAPI}
 */
export class TravelAppConfigApi extends BaseAPI {
    /**
     * get the travel app config
     * @param {} version a version number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelAppConfigApi
     */
    public getTravelAppConfig(version: string, options?: any) {
        return TravelAppConfigApiFp(this.configuration).getTravelAppConfig(version, options)(this.fetch, this.basePath);
    }

}

